<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.evolution_valeur_title' | trans" [accent]="valeurActuelle()" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>
    <vl-widget-period-filters
      [timeScale]="timeScale()"
      (timeScaleChange)="setTimeScale($event)"
      [showPeriod]="false"
      [showComparison]="false"/>
    <mat-icon
      class="refresh-icon cursor-pointer"
      [class.spinning]="refreshing()"
      [class.disabled]="refreshing()"
      [matTooltip]="'dashboard_ui.evolution_valeur_refresh' | trans"
      (click)="refreshing() ? null : refreshNow()">sync</mat-icon>
  </vl-widget-title>

  @if (loading() && !data()) {
    <div class="flex-col gap-8 widget-content">
      <ngx-skeleton-loader count="1" [theme]="{'height': '24px', 'width': '40%', 'background-color': 'var(--color-on-disabled)'}"/>
      <ngx-skeleton-loader count="1" [theme]="{'height': '120px', 'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else if (hasData()) {
    <div class="flex-col gap-8 widget-content fade-in" style="overflow: hidden">
      @if (pinned(); as p) {
        <!-- État épinglé : remplace la ligne « Variation … » sans ajouter de
             contrôle dans l'en-tête (clic sur la courbe pour épingler). -->
        <div class="pinned-chip flex-row gap-6 align-center">
          <mat-icon class="pin-ico">push_pin</mat-icon>
          <span class="caption">Au {{ p.date }} · <strong>{{ p.value }}</strong></span>
          <mat-icon class="pin-close cursor-pointer"
                    matTooltip="Retirer l'épingle"
                    (click)="unpin()">close</mat-icon>
        </div>
      } @else {
        <div class="flex-row gap-8 align-baseline">
          <span class="caption on-background-alt">{{ deltaLabel() }}</span>
          <span class="caption delta-value"
                [class.positive-delta]="deltaClass() === 'positive'"
                [class.negative-delta]="deltaClass() === 'negative'">
            {{ deltaAbsolu() }}
            @if (deltaPercent() !== null) {
              <span class="tiny on-background-alt">({{ deltaPercent() }})</span>
            }
          </span>
        </div>
      }

      @if (needsBackfill()) {
        <div class="banner-cta flex-row gap-8 align-center">
          <mat-icon class="banner-icon">info_outline</mat-icon>
          <span class="grow tiny">{{ 'dashboard_ui.evolution_valeur_partial_warning' | trans }}</span>
          <button type="button" class="banner-btn" [disabled]="refreshing()" (click)="refreshNow()">
            {{ 'dashboard_ui.evolution_valeur_recompute' | trans }}
          </button>
        </div>
      }

      <div class="grow" style="min-height: 0; position: relative">
        @if (singlePoint()) {
          <div class="single-point-hint flex-col align-center justify-center" style="height: 100%; gap: 4px">
            <span class="caption on-background-alt">{{ valeurActuelle() }}</span>
            <span class="tiny on-disabled" style="text-align: center">{{ 'dashboard_ui.evolution_valeur_single_point' | trans }}</span>
          </div>
        } @else {
          <canvas #spark></canvas>
        }
      </div>

      <div class="flex-row align-center justify-end gap-8">
        <vl-chips state="active" size="small" iconRight="open_in_new" (action)="openFullList()">
          {{ 'button.see_all' | trans }}
        </vl-chips>
      </div>
    </div>
  } @else {
    <div class="flex-col gap-8 widget-content align-center justify-center" style="height: 100%">
      <span class="caption on-disabled">{{ 'dashboard_ui.evolution_valeur_empty' | trans }}</span>
      <span class="tiny on-disabled">{{ 'dashboard_ui.evolution_valeur_empty_hint' | trans }}</span>
      <button type="button" class="banner-btn" [disabled]="refreshing()" (click)="refreshNow()">
        {{ 'dashboard_ui.evolution_valeur_recompute' | trans }}
      </button>
    </div>
  }
</div>
